import { Row } from '@ahmdigital/ui';

import {
  FilterBarWrapper,
  GridColumns,
  MobileWrapper,
  StyledButton,
  StyledDisclaimer,
  StyledFindClickable,
  StyledMoreOptionsLink,
  StyledNavigationHeaderTitle,
  StyledStrong,
  TitleWrapper,
} from './styles';
import { ProductType } from '../../../../types/product';
import FilterBar from '../../../filter-bar';
import UpliftedHeader from './uplifted-header';

type DesktopHeaderFilterBarProps = {
  changeUrl: string;
  isCombiningHospitalWithExtras?: boolean;
  isProductListingPage?: boolean;
  isProductListingPageAdd?: boolean;
  isProductListingPageAll?: boolean;
  needsProductType?: ProductType['extrasType'];
  needsType?: string;
  products?: ProductType[];
  title: string;
  titlePrefix: string;
  titleSuffix: string;
  useHeading?: boolean;
};

const DesktopHeaderFilterBar = ({
  changeUrl,
  isCombiningHospitalWithExtras,
  isProductListingPage,
  isProductListingPageAdd,
  isProductListingPageAll,
  needsProductType,
  needsType,
  products,
  title,
  titlePrefix,
  titleSuffix,
  useHeading,
}: DesktopHeaderFilterBarProps) => (
  <FilterBarWrapper isProductPage={!isProductListingPage && !isProductListingPageAdd}>
    {isProductListingPage ? (
      <>
        {isProductListingPageAll && <UpliftedHeader needsType={needsType} products={products} />}
        {!isProductListingPageAll && (
          <>
            <TitleWrapper>
              <StyledNavigationHeaderTitle useHeading={useHeading}>
                <span data-testid="navigation-header-title">
                  {titlePrefix} <StyledStrong>{title}</StyledStrong> {titleSuffix}
                </span>
              </StyledNavigationHeaderTitle>
              {!isCombiningHospitalWithExtras && (
                <StyledFindClickable to={changeUrl}>Find something else</StyledFindClickable>
              )}
            </TitleWrapper>
            <FilterBar needsProductType={needsProductType} needsType={needsType} />
            <MobileWrapper>
              <StyledDisclaimer elementType="button" forProducts={products} highlightIncome showRefineLink={false} />
            </MobileWrapper>
          </>
        )}
      </>
    ) : (
      <GridColumns>
        <Row lgHorizontalAlign="center" verticalAlign="middle">
          <StyledNavigationHeaderTitle useHeading={useHeading}>
            {titlePrefix} <StyledStrong>{title}</StyledStrong>
          </StyledNavigationHeaderTitle>
          {!isCombiningHospitalWithExtras && (
            <StyledButton to={changeUrl} variant="white">
              Change this
            </StyledButton>
          )}
        </Row>
        {!isCombiningHospitalWithExtras && <StyledMoreOptionsLink />}
      </GridColumns>
    )}
  </FilterBarWrapper>
);

export default DesktopHeaderFilterBar;
